import styled from 'styled-components';

export const HereToHelpStyled = styled.div`
  width: 100%;
  background: ${(props) => props.theme.color.white};
  border-top: 1px solid ${(props) => props.theme.color.divider};
  padding: 20px 0;

  .container {
    padding: 0 50px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    column-gap: 30px;
  }

  .text {
    font-size: 20px;
    font-weight: 700;
  }

  .btn {
    font-size: 14px;
    font-weight: 700;
  }

  @media (max-width: 820px) {
    .container {
      padding: 0 15px;
    }
  }

  @media (max-width: 480px) {
    .container {
      flex-direction: column;

      .btn {
        margin: 0;
      }
      .text {
        margin: 0 0 20px 0;
      }
      .mobile-btn-margin {
        margin-right: 0;
      }
    }
  }
`;
